import { Input, InputProps } from '@chakra-ui/react';
import { ChangeEvent, useState, useEffect } from 'react';
import { maskMoney } from '../../../utils/formatters/handleMask';

interface IMoneyInputProps extends Omit<InputProps, 'onChange' | 'value'> {
  value?: number; // valor em centavos
  onChange?: (value: number) => void; // retorna valor em centavos
}

export const MoneyInput = ({
  value = 0,
  onChange,
  ...props
}: IMoneyInputProps): JSX.Element => {
  const [cents, setCents] = useState(String(value));

  useEffect(() => {
    setCents(String(value));
  }, [value]);

  const handleChange = (e: ChangeEvent<HTMLInputElement>): void => {
    const digitsOnly = e.target.value.replace(/\D/g, '');

    const cleanedValue = digitsOnly.replace(/^0+/, '') || '0';

    setCents(cleanedValue);

    const centsValue = parseInt(cleanedValue, 10);

    if (onChange) {
      onChange(centsValue);
    }
  };

  const displayValue = maskMoney(cents);

  return <Input value={displayValue} onChange={handleChange} {...props} />;
};
